import React from 'react';
import { getClassName } from '../../utils/className.js';
import styles from './Divider.module.css';

/**
 * @typedef {Object} DividerProps
 * @property {'horizontal' | 'vertical'} [orientation='horizontal'] - Direction of the divider line.
 * @property {string} [className] - External class merged onto the divider.
 */

/**
 * @param {import('react').HTMLAttributes<HTMLHRElement> & DividerProps} props
 */
const Divider = ({ orientation = 'horizontal', className, ...rest }) => (
  <hr
    className={getClassName([
      styles.divider,
      orientation === 'vertical' ? styles.vertical : styles.horizontal,
      className,
    ])}
    {...rest}
  />
);

export default Divider;
